module.exports = __webpack_public_path__ + "img/share_button.1af89a31.png";